import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { parseRange } from "./dateRange";
/** Canonical calendar state is shareable even on the first visit without query parameters. */
export function useAnalyticsDateRange() {
  const [params, setParams] = useSearchParams();
  const range = parseRange(params);
  useEffect(() => {
    if (
      params.get("start") === range.start &&
      params.get("end") === range.end &&
      params.get("compare") === range.compare
    )
      return;
    const next = new URLSearchParams(params);
    Object.entries({
      start: range.start,
      end: range.end,
      compare: range.compare,
    }).forEach(([key, value]) => next.set(key, value));
    setParams(next, { replace: true });
  }, [params, setParams, range.start, range.end, range.compare]);
  return { params, setParams, range };
}
